import { ToroAccountDetailed } from '../../../api/models/toro-account-detailed.model';
import { createAction, props } from '@ngrx/store';
import { ToroAccountSimple } from '../../../api/models/toro-account-simple.model';
import { Organization } from '../../../api/models/organization.model';
import { RepresentativeAdd } from '../../../api/models/representative-add.model';

export const LoadAccounts = createAction(
    '[Accounts] Load Accounts via service',
    props<{ useCache?: boolean, detailed?: boolean }>()
);

export const LoadAccountsSuccess = createAction(
    '[Accounts] Load Accounts via service Success',
    props<{ accounts: ToroAccountSimple[] }>()
);

export const LoadAccountsFailure = createAction(
    '[Accounts] Load Accounts via service Failed',
    props<{ error: any }>()
);

export const AddRepresentative = createAction(
    '[Accounts] Add Representative Account via service',
    props<{ accountId: number, representative: RepresentativeAdd }>()
);

export const AddRepresentativeSuccess = createAction(
    '[Accounts] Add Representative Account via service Success',
    props<{ accountId: number, representative: RepresentativeAdd }>()
);

export const AddRepresentativeFailure = createAction(
    '[Accounts] Add Representative Account via service Failed',
    props<{ error: any }>()
);

export const SelectAccount = createAction(
    '[Accounts] Select Account',
    props<{ currentAccount: ToroAccountDetailed }>()
);

export const unsetAccount = createAction(
    '[Accounts] Remove selected Account'
);

export const SelectAccountSuccess = createAction(
    '[Accounts] Select Account Success',
    props<{ currentAccount: ToroAccountDetailed }>()
);

export const DeleteAccount = createAction(
    '[Accounts] Delete Account',
    props<{ accountId: number }>()
);

export const DeleteAccountSuccess = createAction(
    '[Accounts] Delete Account via service Success',
    props<{ response: any }>()
);

export const DeleteAccountFailure = createAction(
    '[Accounts] Delete Account via service Failed',
    props<{ error: any }>()
);

export const RemoveRepresentative = createAction(
    '[Accounts] Remove Representative from Account',
    props<{ userId: number, organizationId: number, accountId: number }>()
);

export const RemoveRepresentativeSuccess = createAction(
    '[Accounts] Remove Representative from Account via service Success',
    props<{ userId: number, organizationId: number, accountId: number }>()
);

export const RemoveRepresentativeFailure = createAction(
    '[Accounts] Remove Representative from Account via service Failed',
    props<{ error: any }>()
);

export const UpdateAccount = createAction(
    '[Accounts] Update Account via service',
    props<{ accountId: number, organization: Organization }>()
);

export const UpdateAccountSuccess = createAction(
    '[Accounts] Update Account via service success',
    props<{ isUpdateSuccess: boolean }>()
);

export const UpdateAccountFailure = createAction(
    '[Accounts] Update Account via service Failed',
    props<{ error: any }>()
);

export const accountActionTypes = {

    LoadAccounts,
    LoadAccountsSuccess,
    LoadAccountsFailure,
    AddRepresentative,
    AddRepresentativeSuccess,
    AddRepresentativeFailure,
    SelectAccount,
    unsetAccount,
    SelectAccountSuccess,
    DeleteAccount,
    DeleteAccountSuccess,
    DeleteAccountFailure,
    RemoveRepresentative,
    RemoveRepresentativeSuccess,
    RemoveRepresentativeFailure,
    UpdateAccount,
    UpdateAccountSuccess,
    UpdateAccountFailure
};
